import vuetify from './plugins/vuetify'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'
import "@mdi/font/css/materialdesignicons.css"

import DatePicker from '@/components/DatePicker.vue'
Vue.component('DatePicker', DatePicker)

import GlobalMonth from './components/GlobalMonth'
Vue.component(GlobalMonth.name, GlobalMonth)

import Loading from './components/Loading.vue'
Vue.component(Loading.name, Loading)

import AlertBox from "@/components/AlertBox.vue"
Vue.component("AlertBox", AlertBox)

import VModal from "vue-js-modal"
Vue.use(VModal)

import templatePlugin from '@/plugins/vuetify'
Vue.use(templatePlugin)

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = false

let counter = 0
axios.interceptors.request.use(function (config) {
  counter++
  store.state.loading2.show() // vuex mutation set loading state to true
  return config
}, function (error) {
  return Promise.reject(error)
})
axios.interceptors.response.use(function (config) {
  counter--
  if (counter === 0) {
    store.state.loading2.dialog = false // vuex mutation set loading state to false
  }
  return config
}, function (error) {
  counter--
  if (counter === 0) {
    store.state.loading2.dialog = false // vuex mutation set loading state to false
  }
  return Promise.reject(error)
})
new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app")
